<template>
  <div name="ShowVideo">
    <transition name="ani">
      <div v-if="show" class="border" @click="show = false">
        <div class="content" @click.stop>
          <video controls="controls" ref="videoPlayer" :src="url" class="video-js" style="width: 65vw;
        max-height: 72vh;" preload="auto">
<!--              <source id="" :src="url" type="application/x-mpegURL" >-->
          </video>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
      export default {
            name: "ShowVideo",
            data() {
              return {
                url: "",
                show: false,
                  videoPlayer : null
              };
            },
          mounted() {
                let that = this;
              setTimeout(function () {
                  console.info(that.url)
                  if(this.videoPlayer){
                      that.videoPlayer.play();
                  }else{
                      that.initVideo();
                  }
              }, 1000)

              // if(this.videoPlayer){
              //     this.videoPlayer.play();
              // }else{
              //     this.initVideo();
              // }
          },
          methods: {
              initVideo() {
                  console.info(this.url)
                  this.videoPlayer = this.$video(
                      this.$refs.videoPlayer,
                      {
                          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                          controls: true,
                          //自动播放属性,muted:静音播放
                          autoplay: "false",
                          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                          preload: "auto",
                          //设置视频播放器的显示宽度（以像素为单位）
                          width: "1332px",
                          //设置视频播放器的显示高度（以像素为单位）
                          height: "770px"
                      },
                      function onPlayerReady() {}
                  );
                  this.videoPlayer.src(this.url);
              },
          }
      };
</script>

<style lang="scss" scoped>
  .ani-enter-active,
  .ani-leave-active {
    opacity: 1;
    transition: all 0.3s;
  }

  .ani-enter,
  .ani-leave-to {
    opacity: 0;
  }

  .border {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);

    .content {
      video {
        width: 65vw;
        max-height: 72vh;
      }
    }
  }

    .video-js{
        width: 65vw;
        max-height: 72vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/xm-tools/ShowVideo/ShowVideo.vue